<template>
	<div id="content_body">
		<header-layout :pageHeaderStyle="pageHeaderStyle" :pageHeaderBg="pageHeaderBg" :pageHeaderSpacing="pageHeaderSpacing" :pageHeaderContainer="pageHeaderContainer" :pageTitle="pageTitle" :pageSubtitle="pageSubtitle" :pageIcon="pageIcon"></header-layout>
		<div class="container mt-n15">
			<!-- invoice -->
			<div class="card">
				<vue-collapsible-panel-group>
				<vue-collapsible-panel>
					<template #title>{{ $t('panel.form') }}</template>
					<template #content>
						<div class="card-header">
							<!-- @submit.prevent="handleSubmit()" -->
							<b-form ref="instanceForm" id="instanceForm" autocomplete="off" >
								<!-- Flash -->
								<div v-if="$store.getters.flash.msg" class="alert alert-danger" role="alert" v-html="$store.getters.flash.msg" />
								<div class="form-row">

									<div class="col-md-6">
										<b-form-group class="small mb-1">
											<label>
												{{ $t(instanceClassAttr.instanceClass+'.dateStart')}}
											</label>
											<input type="date" v-model="instance.dateStart" class="form-control" lang="fr" :class="{'is-invalid': v$.instance.dateStart.$error, 'is-valid': (!v$.instance.dateStart.$error && v$.instance.dateStart.$dirty) }" :disabled="typeView=='show'"/>
											<span class="small text-muted d-none d-md-block" v-if="v$.instance.dateStart.$error">
												{{ v$.instance.dateStart.$errors[0].$message }}
											</span>
										</b-form-group>				
									</div>
									<div class="col-md-6">
										<b-form-group class="small mb-1">
											<label>
												{{ $t(instanceClassAttr.instanceClass+'.dateEnd')}}
											</label>
											<input type="date" v-model="instance.dateEnd" class="form-control" lang="fr" :class="{'is-invalid': v$.instance.dateEnd.$error, 'is-valid': (!v$.instance.dateEnd.$error && v$.instance.dateEnd.$dirty) }" :disabled="typeView=='show'"/>
											<span class="small text-muted d-none d-md-block" v-if="v$.instance.dateEnd.$error">
												{{ v$.instance.dateEnd.$errors[0].$message }}
											</span>
										</b-form-group>				
									</div>
									<div class="col-md-6">
										<b-form-group class="small mb-1">
											<label>
												{{ $t(instanceClassAttr.instanceClass+'.lastSolde')}}
											</label>
											<input type="number" step="any" v-model="instance.lastSolde" class="form-control" :class="{'is-invalid': v$.instance.lastSolde.$error, 'is-valid': (!v$.instance.lastSolde.$error && v$.instance.lastSolde.$dirty) }" :disabled="typeView == 'show'" @input="amountToLetter($event, 'lastSolde')" @change="amountLetter = {} "/>
											<span class="small text-muted d-none d-md-block" v-if="v$.instance.lastSolde.$error">
												{{ v$.instance.lastSolde.$errors[0].$message }}
											</span>
											<span v-if="amountLetter && amountLetter.lastSolde != '' " class="amount-letter">
													{{amountLetter.lastSolde}}
												</span>
										</b-form-group>				
									</div>
									<div class="col-md-6">
										<b-form-group class="small mb-1">
											<label>
												{{ $t(instanceClassAttr.instanceClass+'.newSolde')}}
											</label>
											<input type="number" step="any" v-model="instance.newSolde" class="form-control" :class="{'is-invalid': v$.instance.newSolde.$error, 'is-valid': (!v$.instance.newSolde.$error && v$.instance.newSolde.$dirty) }" :disabled="typeView == 'show'" @input="amountToLetter($event, 'newSolde')" @change="amountLetter = {} "/>
											<span class="small text-muted d-none d-md-block" v-if="v$.instance.newSolde.$error">
												{{ v$.instance.newSolde.$errors[0].$message }}
											</span>
											<span v-if="amountLetter && amountLetter.newSolde != '' " class="amount-letter">
													{{amountLetter.newSolde}}
												</span>
										</b-form-group>				
									</div>
									<div class="col-md-6">
										<b-form-group class="small mb-1">
											<label>
												{{ $t(instanceClassAttr.instanceClass+'.amountTotStock')}}
											</label>
											<input type="number" step="any" v-model="instance.amountTotStock" class="form-control" :class="{'is-invalid': v$.instance.amountTotStock.$error, 'is-valid': (!v$.instance.amountTotStock.$error && v$.instance.amountTotStock.$dirty) }" :disabled="typeView == 'show'" @input="amountToLetter($event, 'amountTotS')" @change="amountLetter = {} "/>
											<span class="small text-muted d-none d-md-block" v-if="v$.instance.amountTotStock.$error">
												{{ v$.instance.amountTotStock.$errors[0].$message }}
											</span>
											<span v-if="amountLetter && amountLetter.amountTotS != '' " class="amount-letter">
													{{amountLetter.amountTotS}}
												</span>
										</b-form-group>				
									</div>
									<div class="col-md-6">
										<b-form-group class="small mb-1">
											<label>
												{{ $t(instanceClassAttr.instanceClass+'.amountTotStockOngoing')}}
											</label>
											<input type="number" step="any" v-model="instance.amountTotStockOngoing" class="form-control" :class="{'is-invalid': v$.instance.amountTotStockOngoing.$error, 'is-valid': (!v$.instance.amountTotStockOngoing.$error && v$.instance.amountTotStockOngoing.$dirty) }" :disabled="typeView == 'show'" @input="amountToLetter($event, 'amountTotSO')" @change="amountLetter = {} "/>
											<span class="small text-muted d-none d-md-block" v-if="v$.instance.amountTotStockOngoing.$error">
												{{ v$.instance.amountTotStockOngoing.$errors[0].$message }}
											</span>
											<span v-if="amountLetter && amountLetter.amountTotSO != '' " class="amount-letter">
													{{amountLetter.amountTotSO}}
												</span>
										</b-form-group>				
									</div>
									<div class="col-md-6">
										<b-form-group class="small mb-1">
											<label>
												{{ $t(instanceClassAttr.instanceClass+'.amountCredit')}}
											</label>
											<input type="number" step="any" v-model="instance.amountCredit" class="form-control" :class="{'is-invalid': v$.instance.amountCredit.$error, 'is-valid': (!v$.instance.amountCredit.$error && v$.instance.amountCredit.$dirty) }" :disabled="typeView == 'show'" @input="amountToLetter($event, 'amountC')" @change="amountLetter = {} "/>
											<span class="small text-muted d-none d-md-block" v-if="v$.instance.amountCredit.$error">
												{{ v$.instance.amountCredit.$errors[0].$message }}
											</span>
											<span v-if="amountLetter && amountLetter.amountC != '' " class="amount-letter">
													{{amountLetter.amountC}}
												</span>
										</b-form-group>				
									</div>
									<div class="col-md-6">
										<b-form-group class="small mb-1">
											<label>
												{{ $t(instanceClassAttr.instanceClass+'.amountDebit')}}
											</label>
											<input type="number" step="any" v-model="instance.amountDebit" class="form-control" :class="{'is-invalid': v$.instance.amountDebit.$error, 'is-valid': (!v$.instance.amountDebit.$error && v$.instance.amountDebit.$dirty) }" :disabled="typeView == 'show'" @input="amountToLetter($event, 'amountD')" @change="amountLetter = {} "/>
											<span class="small text-muted d-none d-md-block" v-if="v$.instance.amountDebit.$error">
												{{ v$.instance.amountDebit.$errors[0].$message }}
											</span>
											<span v-if="amountLetter && amountLetter.amountD != '' " class="amount-letter">
													{{amountLetter.amountD}}
												</span>
										</b-form-group>				
									</div>
									<div class="col-md-6">
										<b-form-group class="small mb-1">
											<label>
												{{ $t(instanceClassAttr.instanceClass+'.amountRefund')}}
											</label>
											<input type="number" step="any" v-model="instance.amountRefund" class="form-control" :class="{'is-invalid': v$.instance.amountRefund.$error, 'is-valid': (!v$.instance.amountRefund.$error && v$.instance.amountRefund.$dirty) }" :disabled="typeView == 'show'" @input="amountToLetter($event, 'amountR')" @change="amountLetter = {} "/>
											<span class="small text-muted d-none d-md-block" v-if="v$.instance.amountRefund.$error">
												{{ v$.instance.amountRefund.$errors[0].$message }}
											</span>
											<span v-if="amountLetter && amountLetter.amountR != '' " class="amount-letter">
													{{amountLetter.amountR}}
												</span>
										</b-form-group>				
									</div>
									<div class="col-md-6">
										<b-form-group class="small mb-1">
											<label>
												{{ $t(instanceClassAttr.instanceClass+'.accountTot')}}
											</label>
											<input type="number" step="any" v-model="instance.accountTot" class="form-control" :class="{'is-invalid': v$.instance.accountTot.$error, 'is-valid': (!v$.instance.accountTot.$error && v$.instance.accountTot.$dirty) }" :disabled="typeView == 'show'" @input="amountToLetter($event, 'accTot')" @change="amountLetter = {} "/>
											<span class="small text-muted d-none d-md-block" v-if="v$.instance.accountTot.$error">
												{{ v$.instance.accountTot.$errors[0].$message }}
											</span>
											<span v-if="amountLetter && amountLetter.accTot != '' " class="amount-letter">
													{{amountLetter.accTot}}
												</span>
										</b-form-group>				
									</div>
									<div class="col-md-6">
										<b-form-group class="small mb-1">
											<label>
												{{ $t(instanceClassAttr.instanceClass+'.amountDebitInLoss')}}
											</label>
											<input type="number" step="any" v-model="instance.amountDebitInLoss" class="form-control" :class="{'is-invalid': v$.instance.amountDebitInLoss.$error, 'is-valid': (!v$.instance.amountDebitInLoss.$error
											&& v$.instance.amountDebitInLoss.$dirty) }" :disabled="typeView == 'show'" @input="amountToLetter($event, 'amountDIL')" @change="amountLetter = {} "/>
											<span class="small text-muted d-none d-md-block" v-if="v$.instance.amountDebitInLoss.$error">
												{{ v$.instance.amountDebitInLoss.$errors[0].$message }}
											</span>
											<span v-if="amountLetter && amountLetter.amountDIL != '' " class="amount-letter">
													{{amountLetter.amountDIL}}
												</span>
										</b-form-group>				
									</div>

									<div class="col-md-6">
										<b-form-group class="small mb-1">
											<label>
												{{ $t(instanceClassAttr.instanceClass+'.amountZakat')}}
											</label>
											<input type="number" step="any" v-model="instance.amountZakat" class="form-control" :class="{'is-invalid': v$.instance.amountZakat.$error, 'is-valid': (!v$.instance.amountZakat.$error && v$.instance.amountZakat.$dirty) }" :disabled="typeView == 'show'" @input="amountToLetter($event, 'zakat')" @change="amountLetter = {} "/>
											<span class="small text-muted d-none d-md-block" v-if="v$.instance.amountZakat.$error">
												{{ v$.instance.amountZakat.$errors[0].$message }}
											</span>
											<span v-if="amountLetter && amountLetter.zakat != '' " class="amount-letter">
													{{amountLetter.zakat}}
												</span>
										</b-form-group>				
									</div>
									<div class="col-md-6">
										<b-form-group class="small mb-1">
											<label>
												{{ $t(instanceClassAttr.instanceClass+'.profit')}}
											</label>
											<input type="number" step="any" v-model="instance.profit" class="form-control" :class="{'is-invalid': v$.instance.profit.$error, 'is-valid': (!v$.instance.profit.$error 
											&& v$.instance.profit.$dirty) }" :disabled="typeView == 'show'" @input="amountToLetter($event, 'profit')" @change="amountLetter = {} "/>
											<span class="small text-muted d-none d-md-block" v-if="v$.instance.profit.$error">
												{{ v$.instance.profit.$errors[0].$message }}
											</span>
											<span v-if="amountLetter && amountLetter.profit != '' " class="amount-letter">
													{{amountLetter.profit}}
												</span>
										</b-form-group>				
									</div>
									<div class="col-md-6">
										<b-form-group class="small mb-1">
											<label>
												{{ $t(instanceClassAttr.instanceClass+'.username')}}
											</label>
											<input type="text" v-model="instance.username" class="form-control" :disabled="typeView=='show'" />
										</b-form-group>
									</div>
			
								</div>
								
							</b-form>
							<div class="row">
								<div class="col-md-8" align="left">
									<b-button v-if="typeView != 'show'" class="btn btn-success" 
										@click="handleSubmit()" >
										<span v-if="typeView == 'new'">
											<fa icon="check"/>
											{{ $t("default.button.create")}}
										</span>
										<span v-if="typeView == 'edit'">
											<fa icon="check"/>
											{{ $t("default.button.update")}}
										</span>
									</b-button>
									&ensp;
									<b-button v-if="typeView == 'edit'" class="btn btn-dark" @click="typeView = 'show'" >
										<span>
											<fa icon="times"/>
											{{ $t("default.button.cancel")}}
										</span>
									</b-button>
									
									<b-button v-if="typeView == 'show' " class="btn btn-primary" 
										@click="typeView = 'edit'" >
										<span>
											<fa icon="edit"/>
											{{ $t("default.button.edit")}}
										</span>
									</b-button>

								</div>
								
								<div v-if="typeView == 'show'" class="col-md-4" align="right">
									<b-button id="print"
										variant="primary" class="btn btn-info" type="button" @click="produce('fiche')">
										<fa icon="print"/>
										&nbsp;
										{{this.$t('mvtinventory.button.printFiche')}}
									</b-button>
									<modal-pdf-viewer 
										ref="componentModalPdf" 
										:pdfSrc="pdfSrc"
										:pdfName="pdfName"
									/>
								</div>
							</div>
						</div>
					</template>
				</vue-collapsible-panel>
				<br>
				<vue-collapsible-panel>
					<template #title>{{ $t('servstatestock.list') }}</template>
					<template #content>
						<div v-if="typeView == 'show'" align="right">
							<b-button id="print"
									variant="primary" class="btn btn-info" type="button" @click="produce('stock')">
								<fa icon="print"/>
								&nbsp;
								{{this.$t('mvtinventory.button.printStock')}}
							</b-button>
						</div>
						<div class="card-body p-4 p-md-5">
							<!-- Etat des stocks table-->
							<div class="datatable">
								<datatable-instance
									:instanceClassAttr="instanceClassStock"
									ref="componentDatatableInstanceStock"
								/>
							</div>
							<!-- <div class="table-responsive">
								<table id="instanceTable" class="table table-sm table-striped table-bordered table-hover mb-0">
									<thead class="border-bottom thead-light">
										<tr class="small text-uppercase text-muted">
											<th scope="col" width="25%">
												{{ $t('servstatestock.servType')}}
											</th>
											<th scope="col" width="10%" class="align-center">
												{{ $t('servstatestock.stock')}}
											</th>
											
											<th scope="col" width="10%" class="align-right">
												{{ $t('servstatestock.price')}}
											</th>
											<th scope="col" width="10%" class="align-right">
												{{ $t('servstatestock.amount')}}
											</th>
											<th scope="col" width="15%" class="align-center">
												{{ $t('servstatestock.dateEnd')}}
											</th>
										</tr>
									</thead>
									<tbody>
										
										<tr class="border-bottom" v-for="servStateStock in instance.servStateStocks" :key="servStateStock.id">
											<td>
												<div class="font-weight-bold">
													{{servStateStock.servTypeLib}}
												</div>
											</td>
											<td>
												<div class="font-weight-bold">
													{{$store.getters.formatNumber(servStateStock.stock)}}
												</div>
											</td>
											
											<td>
												<div class="font-weight-bold align-right">
													{{$store.getters.formatAmount(servStateStock.price)}}
												</div>
											</td>
											<td>
												<div class="font-weight-bold align-right">
													{{$store.getters.formatAmount((servStateStock.price * servStateStock.stock) )}}
												</div>
											</td>
											<td>
												<div class="font-weight-bold">
													{{$moment(servStateStock.dateEnd).format($store.getters.formatDate)}}
												</div>
											</td>
										</tr>
									</tbody>
								</table>
							</div> -->
						</div>
					</template>
				</vue-collapsible-panel>
				<br>
				<vue-collapsible-panel>
					<template #title>{{ $t('mvtstateaccount.list') }}</template>
					<template #content>
						<div v-if="typeView == 'show'" align="right">
							<b-button id="print"
									variant="primary" class="btn btn-info" type="button" @click="produce('account')">
								<fa icon="print"/>
								&nbsp;
								{{this.$t('mvtinventory.button.printAccount')}}
							</b-button>
						</div>
						<div class="card-body p-4 p-md-5">
							<!-- Etat des Account table-->
							<div class="datatable">
								<datatable-instance
									:instanceClassAttr="instanceClassAccount"
									ref="componentDatatableInstanceAccount"
								/>
							</div>
							<!-- <div class="table-responsive">
								<table id="instanceTable" class="table table-sm table-striped table-bordered table-hover mb-0">
									<thead class="border-bottom thead-light">
										<tr class="small text-uppercase text-muted">
											<th scope="col" width="55%">
												{{ $t('mvtstateaccount.mvtAccount')}}
											</th>
											
											<th scope="col" width="15%" class="align-center">
												{{ $t('mvtstateaccount.dateEnd')}}
											</th>
											<th scope="col" width="30%" class="align-right">
												{{ $t('mvtstateaccount.amount')}}
											</th>
										</tr>
									</thead>


									

									<tbody>
										
										<tr class="border-bottom" v-for="mvtStateAccount in instance.mvtStateAccounts" :key="mvtStateAccount.id">
											<td>
												<div class="font-weight-bold">
													{{mvtStateAccount.mvtAccountLib}}
												</div>
											</td>
											<td>
												<div class="font-weight-bold">
													{{$moment(mvtStateAccount.dateEnd).format($store.getters.formatDate)}}
												</div>
											</td>
											<td>
												<div class="font-weight-bold align-right">
													{{$store.getters.formatAmount(mvtStateAccount.amount)}}
												</div>
											</td>
											
										</tr>
									</tbody>
								</table>
							</div> -->

						</div>
					</template>
				</vue-collapsible-panel>
			</vue-collapsible-panel-group>


				
			</div>
		</div>
	</div>
</template>
<script>
	import Header from '@/layouts/templates/Header.vue';
	import ModalPdfViewer from '@/components/templates/Modals/ModalPdfViewer.vue';
	import DatatableInstance from '@/components/templates/datatables/DatatableInstance.vue'
	import { useVuelidate } from '@vuelidate/core'
	import { required, email,minLength, maxLength } from '@vuelidate/validators'
	export default {
		name: 'mvtInventory',
		props: {
			itemId: {
				type: Number,
				default: NaN,
				required: false
			},
		},
		setup () { return { v$: useVuelidate() }},
		components: {
			'header-layout': Header,
			'modal-pdf-viewer': ModalPdfViewer,
			'datatable-instance': DatatableInstance,
		},
		data() {
			return {
				pageHeaderStyle: process.env.VUE_APP_PAGE_HEADER_STYLE,
				pageHeaderBg: process.env.VUE_APP_PAGE_HEADER_BG,
				pageHeaderSpacing: 'pb-10',
				pageHeaderContainer: 'container',
				pageSubtitle: this.$t('mvtinventory.label'),
				pageTitle: this.$t('mvtinventory.show'),
				pageIcon: 'archive',
				instanceClassAttr: {
					instanceClass: 'mvtinventory'
				},
				instanceClassStock: {
					instanceClass: 'servstatestock',
					typeItems: 'itemsInit',
					actCol: {
						actDisplay: false, 
						thCol: '10%',
						thClass: 'align-center',
						// actAlign: 'right',
						actAdd: false, 
						actGet: false, 
						actEdit: false, 
						actDel: false
					},
					attrsList:[
						{attrName:'servTypeLib', thStyle: {width:'35%'}, thClass:'align-center'},
						{attrName:'stock', thStyle: {width:'15%'}, thClass:'align-center', searchable: true, sortable: true},
						{attrName:'price', thStyle: {width:'15%'}, thClass:'align-center', searchable: true, sortable: true},
						{attrName:'amount', thStyle: {width:'20%'}, thClass:'align-center', searchable: true, sortable: true},
						{attrName:'dateEnd', thStyle: {width:'15%'}, thClass:'align-center', searchable: true, sortable: true}
					]
				},
				instanceClassAccount: {
					instanceClass: 'mvtstateaccount',
					typeItems: 'itemsInit',
					actCol: {
						actDisplay: false, 
						thCol: '10%',
						thClass: 'align-center',
						// actAlign: 'right',
						actAdd: false, 
						actGet: false, 
						actEdit: false, 
						actDel: false
					},
					attrsList:[
						{attrName:'mvtAccountLib', thStyle: {width:'55%'}, thClass:'align-center'},
						{attrName:'dateEnd', thStyle: {width:'15%'}, thClass:'align-center', searchable: true, sortable: true},
						{attrName:'amount', thStyle: {width:'30%'}, thClass:'align-center', searchable: true, sortable: true}
					]
				},

				instance: {},
				vueRules: {},
				amountLetter: {},
				typeView: 'new',
				pdfSrc:'',
				pdfName:"Bon de l'inventaire",				
			}
		},
		validations () {
			return this.vueRules
		},
		created (){
			this.vueRules = this.createVeerules()
		},
		async mounted () {
			this.$store.dispatch('initFlash');

			if(this.$store.getters.loggedIn) {
			
				if(this.itemId && !isNaN(this.itemId)){
					this.typeView = 'show'
					await this.$store.dispatch('axiosGet', {
						domain: 'mvtinventory',
						id: this.itemId
					})
					.then(response => {
						this.instance = response.data
						this.pageSubtitle = this.instance.lib
						this.instance.dateStart = this.instance.dateStart.split('T')[0]
						this.instance.dateEnd = this.instance.dateEnd.split('T')[0]

						this.$refs.componentDatatableInstanceStock.refreshDataTable(this.instance.servStateStocks);

						this.$refs.componentDatatableInstanceAccount.refreshDataTable(this.instance.mvtStateAccounts);

						//this.instance.profit = this.$store.getters.formatAmount(this.instance.profit)

						this.amountToLetter({target:{value:this.instance.profit?.toString()}}, 'profitRep')

						this.amountToLetter({target:{value:this.instance.amountTotStock?.toString()}}, 'amountTotStockRep')

						

					})
					.catch(error => {
						console.log('error catch get mvtinventory by itemId == ', error.message)
					})
				}
				else {
					await this.$store.dispatch('axiosGet', { url: '/api/mvtinventory/create'
					})
					.then(response => {
						if(response.data){
							this.instance = response.data;
							this.instance.dateStart = this.instance.dateStart.split('T')[0]
							this.instance.dateEnd = this.instance.dateEnd.split('T')[0]
						}

					})
					.catch(error => {
						console.log('error catch - mvtinventory - creates == ', error.message)
					})
					this.instance.username = this.$store.getters.username
				}

				
			}
		},
		methods: {
			createVeerules(){
				let rules = {
					instance: {
						amountTotStock: { required },
						amountTotStockOngoing: {required},
						accountTot: {required},
						lastSolde: {required},
						newSolde: {required},
						profit: {required},
						amountCredit: { required },
						amountDebit: {required},
						amountRefund: {required},
						amountZakat: {required},
						amountDebitInLoss: {required},
						dateStart: { required },
						dateEnd: {required},
						username: {required},
						
					}
				}
				return rules
			},
			async amountToLetter(e, attrName) {
				if(e.target.value && e.target.value.length > 2 && attrName && attrName != ''){
					await this.$store.dispatch('axiosGet', { url: '/api/sequence/convert?amount='+e.target.value
					})
					.then(response => {
						if(response.data && response.data.results)
							this.amountLetter[attrName] = response.data.results
					}).catch(error => {
						console.log('error catch convert amount == ', error.message)
					})
				}
			},
			async handleSubmit() {
				const result = await this.v$.$validate()
				if (!result)
					return
				else{
					this.$store.dispatch('initFlash');
					this.$store.dispatch('loading')
					this.axiosPost()
				}
			},
			
			async axiosPost() {
				try {
					if(this.itemId && !isNaN(this.itemId)){
						await this.$store.dispatch('axiosPut', {
							domain: 'mvtinventory',
							data: this.instance,
							id:this.itemId
						})
						.then(res => {
							this.$nextTick(() => {
								let msg = this.$t("mvtinventory.label") + " "+this.itemId;
								if(res.data && res.data.error){
									msg = msg+ ' '+ res.data.error;
									this.$store.dispatch('showToast', {
										type: 'warning', message: msg
									});
									this.$router.push('/inventory/show/'+this.itemId)
								}
								else{
									this.$store.dispatch('showToast', {
										type: 'success', message: this.$t('toast.updated.message', { obj: msg})
									});
									this.$router.go(0)
								}
								this.$store.dispatch('unloading')
							});
						})
						.catch(error => {
							console.log('error axiosPut === ', error)
							this.$store.getters.getErrorMsgFormatted(error);
							this.$store.dispatch('unloading')
						})
					}
					else {
						await this.$store.dispatch('axiosPost', {
							domain: 'mvtinventory',
							data: this.instance
						})
						.then(res => {
							this.$nextTick(() => {
								let msg = this.$t("mvtinventory.label") + " "+res.data.id;
								if(res.data && res.data.error){
									msg = msg+ ' '+ res.data.error;
									this.$store.dispatch('showToast', {
										type: 'warning', message: msg
									});
									this.$router.push('/inventory/show/'+res.data.id)
								}
								else{
									this.$store.dispatch('showToast', {
										type: 'success', message: this.$t('toast.created.message', { obj: msg})
									});
									this.$router.go(0)
								}
								this.$store.dispatch('unloading')
							});
						})
						.catch(error => {
							console.log('error axiosPost === ', error)
							this.$store.getters.getErrorMsgFormatted(error);
							this.$store.dispatch('unloading')
						})
					}
				
				}
				catch (e) {
					console.log('Error ', e)
				}

			},
			async produce(type) {
				this.$store.dispatch('loading', this.$t('toast.produce.message'))
				let modelName = "FICHE DE L'INVENTAIRE DU "+ this.$moment(this.instance.dateStart).format(this.$store.getters.formatDateShort) + ' AU '+ this.$moment(this.instance.dateEnd).format(this.$store.getters.formatDateShort);

				let titreDoc = 'null';

				let strParamsForms = "";
				let instCl = 'mvtinventory';
				let attrsRepList = [];
				let attrsRepLibList = [];

				let detailsTopC1 = '';
				let detailsTopC2 = '';

				let trFoot = ''
				let	detailsBot = '';
				let libBot = ''
				let detailsBot3C = '<i> Bamako le, </i> <b>' + this.$moment(this.instance.dateCreated).format(this.$store.getters.formatDateShort) + '</b>';

				// 1 - Fiche
				if(type == 'fiche'){
					detailsTopC1 = '<i> '+ this.$t('mvtinventory.amountTotStock') +' : </i> <b> ' +this.$store.getters.formatAmount(this.instance?.amountTotStock) + '</b>';

					detailsTopC2 = '<i> '+ this.$t('mvtinventory.amountTotStockOngoing') +' : </i> <b> ' +this.$store.getters.formatAmount(this.instance?.amountTotStockOngoing) + '</b>';

					
					detailsTopC1 = detailsTopC1 + '<br><i> '+ this.$t('mvtinventory.amountCredit') +' : </i> <b> ' +this.$store.getters.formatAmount(this.instance?.amountCredit) + '</b>';

					detailsTopC2 = detailsTopC2 +'<br><i> '+ this.$t('mvtinventory.amountDebit') +' : </i> <b> ' +this.$store.getters.formatAmount(this.instance?.amountDebit) + '</b>';

					detailsTopC1 = detailsTopC1 + '<br><i> '+ this.$t('mvtinventory.accountTot') +' : </i> <b> ' +this.$store.getters.formatAmount(this.instance?.accountTot) + '</b>';

					detailsTopC2 = detailsTopC2 +'<br><i> '+ this.$t('mvtinventory.amountRefund') +' : </i> <b> ' +this.$store.getters.formatAmount(this.instance?.amountRefund) + '</b>';

					trFoot = '<i> '+ this.$t('mvtinventory.lastSolde') +' : </i> <b>' +this.$store.getters.formatAmount(this.instance.lastSolde) + '</b>';
				
					if(trFoot != '')
						trFoot = trFoot + '<br>'
					trFoot = trFoot + '<i> '+ this.$t('mvtinventory.newSolde') +' : </i> <b>' +this.$store.getters.formatAmount(this.instance.newSolde) + '</b>';
					if(trFoot != '')
						trFoot = trFoot + '<br>'
					trFoot = trFoot + '<i> '+ this.$t('mvtinventory.amountZakat') +' : </i> <b>' +this.$store.getters.formatAmount(this.instance.amountZakat) + '</b>';

					let labelProfit = this.$t('mvtinventory.profit')
					if(this.instance.profit > 0)
						labelProfit = this.$t('mvtinventory.profitB')
					else
						labelProfit = this.$t('mvtinventory.profitP')
					libBot = '<i> '+ labelProfit +' : </i> <b>'+this.$store.getters.formatAmount(this.instance.profit) +'</b>';

					detailsBot = '<i><b> '+this.amountLetter.profitRep +'</b> </i>';			
				}

				else if(type == 'account'){
					instCl = 'mvtstateaccount';

					titreDoc = this.$t('mvtstateaccount.list')
					attrsRepList = ['mvtAccount', 'dateEnd', 'amount']
					attrsRepLibList = ['Compte', 'Date de clôture', 'Solde']

					strParamsForms = "params1=mvtInventory.id&valParams1="+this.itemId +"&logParams1=eqL"
					strParamsForms = strParamsForms + "&attrsRepList=" +attrsRepList.toString()+"&attrsRepLibList="+attrsRepLibList.toString()

				}
				else if(type == 'stock'){
					instCl = 'servstatestock';

					titreDoc = this.$t('servstatestock.list')
					attrsRepList = ['servType', 'stock', 'price','dateEnd', 'getAmount()']
					attrsRepLibList = ['Compte', 'Stock', 'P.U', 'Date de clôture', 'Montant']

					strParamsForms = "params1=mvtInventory.id&valParams1="+this.itemId +"&logParams1=eqL"
					strParamsForms = strParamsForms + "&attrsRepList=" +attrsRepList.toString()+"&attrsRepLibList="+attrsRepLibList.toString()

					trFoot = '<i> '+ this.$t('mvtinventory.amountTotStock') +' : </i> <b>'+this.$store.getters.formatAmount(this.instance.amountTotStock) +'</b>';
					libBot = '<i><b> '+this.amountLetter.amountTotStockRep +'</b> </i>';

				}

  
				let	detailsTop = '<FONT size=4><b>'+modelName+' </b> </FONT>';
				
				let strParams = "jasper=LIC&typeList=criteria&strFormat=PDF"

				if(detailsTop != '')
					strParams = strParams +"&detailsTop="+detailsTop
				if(detailsTopC1 != '')
					strParams = strParams +"&detailsTopC1="+detailsTopC1
				if(detailsTopC2 != '')
					strParams = strParams +"&detailsTopC2="+detailsTopC2
				if(trFoot != '')
					strParams = strParams +"&trFoot="+trFoot

				if(libBot != '')
					strParams = strParams +"&libBot="+libBot

				if(detailsBot != '')
					strParams = strParams +"&detailsBot="+detailsBot
				if(detailsBot3C != '')
					strParams = strParams +"&detailsBot3C="+detailsBot3C
				
				if(strParamsForms != "")
					strParams = strParams +"&"+strParamsForms

				strParams = strParams + "&titreDoc="+titreDoc

				let fileName = modelName
				strParams = strParams + "&fileName="+ fileName
			
				await this.$store.dispatch('axiosGet', {
					url: '/api/'+instCl+'/produce?' + strParams, strResponseType: 'blob'
				})
				.then(response => {
					var fileURL = window.URL.createObjectURL(new Blob([response.data]));
					this.pdfName = fileName+'.pdf'
					this.pdfSrc = fileURL
					this.$nextTick(()=> {
						this.$refs.componentModalPdf.modalToggle();
					});
					
				})
				.catch(error => {
					console.log('error catch == ', error.message)
				})
				this.$store.dispatch('unloading')
			},
		}

	}

</script>